import _objectSpread from "/home/jenkins/workspace/tServices_Forms_Client_CICD_main/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import { jsx as _jsx } from "react/jsx-runtime";

var SvgTextBold = function SvgTextBold(props) {
  return _jsx("svg", _objectSpread(_objectSpread({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    role: "img"
  }, props), {}, {
    children: _jsx("path", {
      fill: props.color || '#909090',
      d: "M6.743 2c1.079 0 1.984.1 2.715.303.732.19 1.277.504 1.637.94.371.438.557 1.026.557 1.765 0 .46-.081.874-.244 1.244-.162.37-.4.672-.714.908-.301.235-.679.392-1.131.47v.084c.464.079.876.224 1.236.437.371.202.661.499.87.891.22.381.331.885.331 1.513 0 .728-.18 1.35-.54 1.865-.36.516-.876.908-1.549 1.177-.661.269-1.45.403-2.367.403H4.2A1.2 1.2 0 0 1 3 12.8V3.2A1.2 1.2 0 0 1 4.2 2h2.543Zm.296 4.89c.882 0 1.485-.134 1.81-.403.337-.269.505-.666.505-1.193 0-.538-.197-.924-.592-1.16-.395-.235-1.027-.352-1.897-.352H5.228V6.89h1.81Zm-1.81 1.732v3.58h2.019c.905 0 1.532-.168 1.88-.505.36-.336.54-.784.54-1.344 0-.359-.076-.667-.227-.924-.15-.258-.412-.454-.783-.589-.372-.145-.877-.218-1.515-.218H5.228Z"
    })
  }));
};

export default SvgTextBold;